<template>
  <div class="w-full lg:flex lg:items-center lg:h-screen pt-5 lg:pt-0">
    <div
      class="flex md:justify-end justify-center w-1/4 lg:w-auto md:pt-8 pt-2"
    >
      <logo-icon v-if="breakpoints.w < 1000" />
    </div>
    <router-view />
  </div>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  name: 'Auth',
  components: {
    logoIcon: () => import('@/assets/images/AppLogo.vue')
  },
  data () {
    return {
      breakpoints
    }
  }
}
</script>

<style scoped>
>>> .el-input__inner:focus {
  border-color: #818799;
}
>>> .el-input__inner {
  background-color: white;
  color: #757575;
  height: 50px;
  border: 1px solid var(#e0e0e0);
}
>>> .el-form--label-top .el-form-item__label {
  color: #616161;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  padding: 0 0 0 0;
}
</style>
